import http from './receipt-model-api.http';
import { ReceiptModelAPI, RefundOrigin } from './receipt-model-api.types';

export default {
  cancelTransfer: async (transferId: string, reason: string): Promise<void> => {
    await http.post(`/v1/transfers/${transferId}/cancel`, {
      reason,
    });
  },

  forceTransferPayment: async (transferId: string, reason: string): Promise<void> => {
    await http.post(`/v1/transfers/${transferId}/force-payment`, {
      reason,
    });
  },

  getReceiptModel: async (projectId: string): Promise<ReceiptModelAPI.ReceiptModelResponse> => {
    const res = await http.get<ReceiptModelAPI.ReceiptModelResponse>(
      `/receipt-model/${projectId}`,
    );

    return res.data;
  },

  refundTransfers: async (
    projectId: string,
    reason: string,
    origin: RefundOrigin,
  ): Promise<void> => {
    await http.post(`/receipt-model/${projectId}/refund-transfers`, {
      origin,
      reason,
    });
  },
};
